export enum QueryStatus {
  ERROR = 'error',
  SUCCESS = 'success',
}
